import JSEncrypt from 'jsencrypt'
const VUE_APP_MQTT_PUBLIC_KEY = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAwv35Rkkj9b5aj7dyIXrD 
Y8YyVb4R2HZqA+8Fdamnk04JCOkS3GjQ8dVvZ/S9C90ngUr7dJ4rxKsCMekFP1ig 
lQtJJrWIFmgKZ5wRHYJD2EQol7AvtjgNbpP0ZKem2dlQd5p3M+6Az67pk8j/w672 
YXRzXZ/4NLhZz5inHxyrY9prjO4gAOOeJ3EPsGm/cDaE22WLV//mr52ZhGxkgGOl 
kkEZydo1OQA8jmYrCv4RS+nVau7hVPUNE2RuISJg1v9UbdZ+4qQdL7Ve3z56Rkdv 
PPn5E1NpHwhYm6ZrWajXBlcG5px99EMlcgblJ5oZXKZmP2GZXANOpMXksFh2vpcP 
SQIDAQAB`

export const encryptWithPublicKey = (data) => {
    try {
        const encryptor = new JSEncrypt()
        encryptor.setPublicKey(VUE_APP_MQTT_PUBLIC_KEY)
        const encryptedData = encryptor.encrypt(data);
        return encryptedData
    } catch (error) {
        console.error('加密失败:', error)
        return null
    }
}